import { Component, OnInit, NgModule, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import * as _moment from 'moment';
import { map } from 'rxjs/operators';
import { AppComponent } from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
export interface isGetReportDetail {
  ReportID: string;
  ReportName: string;
  type: string;
}
export interface ReportConfigInsert {
  pRowID: number;
  RepID: string;
  RepName: string;
  ReportString: string;
  DateCaptionText: string;
  DateCaptionValue: string;
  ScheduleType: number;
  Schedule: string;
  OptionID: string;
  ReportFooter: string;
  FromUserID: string;
  EmailUser: string;
  recEnable: number;
  SendBlankMail: number;
  ReportGroupID: string;
}

export interface EmailUserList {
  ID: number;
  UserName: string;
  Mobile: string;
  Email: string;
  Type: string;
}

@Component({
  selector: 'app-report-configuration',
  templateUrl: './report-configuration.component.html',
  styleUrls: ['./report-configuration.component.css'],
  standalone: false
})
export class ReportConfigurationComponent implements OnInit {
  @ViewChild('ModalPopUP') ModalPopUP: any;

  configReportForm!: FormGroup;
  url: string;
  RightsID: string = '';
  RepportsName: string = '';
  ReportGroup: any[] = [];
  FromUserList: any[] = [];
  emailList: any[] = [];
  selectedEmail: number[] = [];

  RouteReportGroup: string = '';
  RouteUser: string = '';

  ReportID: string = '0';
  ReportConfigID: string = '0';
  ReportDisplayID: number = 0;
  DisplayColumn: number = 0;
  ScheduleType: number = 1;

  filterData: string = '';
  schedule: string = '';
  DateCaptionText: string = '';
  DateCaptionValue: string = '';

  ModelFor: string = '';
  modalURL: string = '';
  CallFunctionOnCloseModal: string = '';

  isSaving: boolean = false;
  showScheduleError: boolean = false;

  // Schedule options
  dailyHours = Array.from({ length: 24 }, (_, i) => ({
    value: i,
    label: `${i.toString().padStart(2, '0')}:00`
  }));

  monthlyDays = Array.from({ length: 31 }, (_, i) => ({
    value: i,
    label: (i + 1).toString().padStart(2, '0')
  }));

  weeklyDays = [
    { value: 0, label: 'Mon' },
    { value: 1, label: 'Tue' },
    { value: 2, label: 'Wed' },
    { value: 3, label: 'Thu' },
    { value: 4, label: 'Fri' },
    { value: 5, label: 'Sat' },
    { value: 6, label: 'Sun' }
  ];

    // Column selection info
  selectedColumnCount: number = 0;
  selectedColumnPreview: string = '';
  
  constructor(
    private router: Router,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private alertService: AlertService
  ) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit(): void {
    this.checkUserRights();
    this.initializeForm();
    this.loadInitialData();
    this.getRouteConfig();
    this.getReportIdFromUrl();
  }

  // Form getter for easy access
  get f(): { [key: string]: AbstractControl } {
    return this.configReportForm.controls;
  }

  private checkUserRights(): void {
    this.RightsID = localStorage.getItem('UserRight') || '';
    const allowedRights = ['202018001', '202018021', '202018000'];

    if (!allowedRights.some(right => this.RightsID.includes(right))) {
      this.router.navigate(['/module/0']);
    }
  }

  private initializeForm(): void {
    this.configReportForm = this.formBuilder.group({
      ReportName: ['', [Validators.required, Validators.maxLength(100)]],
      GroupNameReport: ['0'],
      drpEmail: [[], Validators.required],
      checkFor: [true],
      checkTo: [true],
      ReportFooter: ['', Validators.maxLength(500)],
      FromUser: ['0', Validators.required],
      reportEnable: [true],
      sendBlankMail: [false],
      ScheduleType: [1],

      // Weekly schedule controls
      chkWeek0: [false], chkWeek1: [false], chkWeek2: [false],
      chkWeek3: [false], chkWeek4: [false], chkWeek5: [false], chkWeek6: [false],

      // Monthly schedule controls (0-30)
      ...this.createMonthlyControls(),

      // Daily schedule controls (0-23)
      ...this.createDailyControls()
    });

    // Add custom validator for schedule selection
    // this.configReportForm.setValidators(this.scheduleValidator.bind(this));
  }

  private createMonthlyControls(): any {
    const controls: any = {};
    for (let i = 0; i <= 30; i++) {
      controls[`chkMonthly${i}`] = [false];
    }
    return controls;
  }

  private createDailyControls(): any {
    const controls: any = {};
    for (let i = 0; i <= 23; i++) {
      controls[`chkDaily${i}`] = [false];
    }
    return controls;
  }

  // private scheduleValidator(group: FormGroup): { [key: string]: any } | null {
  //   const scheduleType = group.get('ScheduleType')?.value;
  //   let hasSelection = false;

  //   if (scheduleType === 1) { // Daily
  //     for (let i = 0; i <= 23; i++) {
  //       if (group.get(`chkDaily${i}`)?.value) {
  //         hasSelection = true;
  //         break;
  //       }
  //     }
  //   } else if (scheduleType === 2) { // Monthly
  //     for (let i = 0; i <= 30; i++) {
  //       if (group.get(`chkMonthly${i}`)?.value) {
  //         hasSelection = true;
  //         break;
  //       }
  //     }
  //   } else if (scheduleType === 3) { // Weekly
  //     for (let i = 0; i <= 6; i++) {
  //       if (group.get(`chkWeek${i}`)?.value) {
  //         hasSelection = true;
  //         break;
  //       }
  //     }
  //   }

  //   this.showScheduleError = !hasSelection && this.configReportForm?.get('ScheduleType')?.touched;
  //   return hasSelection ? null : { scheduleRequired: true };
  // }

  private loadInitialData(): void {
    this.getUserListing().subscribe({
      next: (data) => this.emailList = data,
      error: (error) => this.alertService.showError('Failed to load email list')
    });

    this.http.get(this.url + 'GM/GetEmployee').subscribe({
      next: (data) => this.FromUserList = JSON.parse(data.toString()),
      error: (error) => this.alertService.showError('Failed to load user list')
    });

    this.getMaster('125', '').subscribe({
      next: (data: any) => this.ReportGroup = data,
      error: (error) => this.alertService.showError('Failed to load report groups')
    });
  }

  private getRouteConfig(): void {
    this.RouteReportGroup = this.hasRights(['202042000', '202042001', '202042021'])
      ? '/general-master/125'
      : '/module/0';

    this.RouteUser = this.hasRights(['202040000', '202040001', '202040021'])
      ? '/user-master'
      : '/module/0';
  }

  private getReportIdFromUrl(): void {
    const pageurl = this.router.url;
    const pagehead = pageurl.split('/');
    this.ReportID = pagehead[2] || '0';
    this.ReportConfigID = pagehead[3] || '0';

    if (+this.ReportConfigID === 0) {
      this.loadNewReportConfig();
    } else if (+this.ReportConfigID > 0) {
      this.loadExistingReportConfig();
    }
  }

  private loadNewReportConfig(): void {
    this.DisplayColumn = 0;
    this.ReportDisplayID = 0;
    this.filterData = localStorage.getItem('filterValue') || '';
    this.loadReportDetails();
  }

  private loadReportDetails(): void {
    this.http.get(this.url + 'Report/GetReportDetail?ReportId=' + this.ReportID)
      .subscribe({
        next: (data) => {
          if (data) {
            const reportDetail = JSON.parse(data.toString())[0];
            this.RepportsName = reportDetail.ReportName;
          }
        },
        error: (error) => this.alertService.showError('Failed to load report details')
      });
  }

  private loadExistingReportConfig(): void {
    this.ReportDisplayID = 1;

    this.http.get(this.url + 'Report/GetReportDetail?ReportId=' + this.ReportID)
      .subscribe({
        next: (data) => {
          if (data) {
            const reportDetail = JSON.parse(data.toString())[0];
            this.DisplayColumn = reportDetail.type?.trim() === 'L' ? 1 : 0;
            this.RepportsName = reportDetail.ReportName;
          }
        },
        error: (error) => this.alertService.showError('Failed to load report details')
      });

    this.http.get(this.url + 'Report/GetReportConfig?ID=' + this.ReportConfigID)
      .subscribe({
        next: (data) => {
          if (data) {
            this.populateFormWithConfig(JSON.parse(data.toString())[0]);
          }
        },
        error: (error) => this.alertService.showError('Failed to load report configuration')
      });
  }

  private populateFormWithConfig(config: any): void {
    // Set date scale values
    const scaleTypes = config.DateCaptionValue.split('|', 3);
    this.configReportForm.patchValue({
      checkFor: scaleTypes[0] === '1',
      checkTo: scaleTypes[1] === '1'
    });

    this.ScheduleType = config.ScheduleType;
    this.setScheduleValue(config.Schedule);

    this.selectedEmail = config.EmailUser.toString().split(',').map(Number);
    this.filterData = config.ReportString;

    this.configReportForm.patchValue({
      ScheduleType: config.ScheduleType.toString(),
      ReportName: config.RepName,
      GroupNameReport: config.ReportGroupID,
      ReportFooter: config.ReportFooter,
      FromUser: config.FromUserID,
      reportEnable: config.recEnable === 1,
      sendBlankMail: config.SendBlankMail === 1
    });

    this.configReportForm.get('drpEmail')?.setValue(this.selectedEmail);
  }

  private setScheduleValue(schValue: string): void {
    const scheduleVals = schValue.split('|', 50);
    const patchValues: any = {};

    scheduleVals.forEach(value => {
      if (value) {
        const numValue = parseInt(value, 10);
        if (this.ScheduleType === 1 && numValue >= 0 && numValue <= 23) {
          patchValues[`chkDaily${numValue}`] = true;
        } else if (this.ScheduleType === 2 && numValue >= 0 && numValue <= 30) {
          patchValues[`chkMonthly${numValue}`] = true;
        } else if (this.ScheduleType === 3 && numValue >= 0 && numValue <= 6) {
          patchValues[`chkWeek${numValue}`] = true;
        }
      }
    });

    this.configReportForm.patchValue(patchValues);
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.configReportForm.get(fieldName);
    return field ? (field.touched && field.invalid) : false;
  }

  hasRights(rights: string[]): boolean {
    return rights.some(right => this.RightsID.includes(right));
  }

  onScheduleTypeChange(type: number): void {
    this.ScheduleType = type;
    this.resetScheduleControls();
    this.configReportForm.get('ScheduleType')?.markAsTouched();
    this.configReportForm.updateValueAndValidity();
  }

  private resetScheduleControls(): void {
    const resetValues: any = {};

    // Reset weekly
    for (let i = 0; i <= 6; i++) {
      resetValues[`chkWeek${i}`] = false;
    }

    // Reset monthly
    for (let i = 0; i <= 30; i++) {
      resetValues[`chkMonthly${i}`] = false;
    }

    // Reset daily
    for (let i = 0; i <= 23; i++) {
      resetValues[`chkDaily${i}`] = false;
    }

    this.configReportForm.patchValue(resetValues);
    this.showScheduleError = false;
  }

  private compileSchedule(): void {
    const formValue = this.configReportForm.value;
    this.schedule = '';

    if (this.ScheduleType === 1) { // Daily
      for (let i = 0; i <= 23; i++) {
        if (formValue[`chkDaily${i}`]) {
          this.schedule += i + '|';
        }
      }
    } else if (this.ScheduleType === 2) { // Monthly
      for (let i = 0; i <= 30; i++) {
        if (formValue[`chkMonthly${i}`]) {
          this.schedule += i + '|';
        }
      }
    } else if (this.ScheduleType === 3) { // Weekly
      for (let i = 0; i <= 6; i++) {
        if (formValue[`chkWeek${i}`]) {
          this.schedule += i + '|';
        }
      }
    }

    this.schedule = this.schedule.slice(0, -1); // Remove trailing |
  }

  private compileDateCaption(): void {
    const formValue = this.configReportForm.value;
    this.DateCaptionText = '';
    this.DateCaptionValue = '';

    if (formValue.checkFor) {
      this.DateCaptionText += 'From|';
      this.DateCaptionValue += '1|';
    } else {
      this.DateCaptionText += '|';
      this.DateCaptionValue += '0|';
    }

    if (formValue.checkTo) {
      this.DateCaptionText += 'To|';
      this.DateCaptionValue += '1|';
    } else {
      this.DateCaptionText += '|';
      this.DateCaptionValue += '0|';
    }
  }
  toggleDaily(hour: number): void {
    const control = this.configReportForm.get(`chkDaily${hour}`);
    control?.setValue(!control.value);
    control?.markAsTouched();
    this.configReportForm.updateValueAndValidity();
  }

  toggleMonthly(day: number): void {
    const control = this.configReportForm.get(`chkMonthly${day}`);
    control?.setValue(!control.value);
    control?.markAsTouched();
    this.configReportForm.updateValueAndValidity();
  }

  toggleWeekly(day: number): void {
    const control = this.configReportForm.get(`chkWeek${day}`);
    control?.setValue(!control.value);
    control?.markAsTouched();
    this.configReportForm.updateValueAndValidity();
  }

   // Select all methods
  selectAllDaily(select: boolean): void {
    const patch: any = {};
    for (let i = 0; i <= 23; i++) {
      patch[`chkDaily${i}`] = select;
    }
    this.configReportForm.patchValue(patch);
    this.configReportForm.updateValueAndValidity();
  }

  selectAllMonthly(select: boolean): void {
    const patch: any = {};
    for (let i = 0; i <= 30; i++) {
      patch[`chkMonthly${i}`] = select;
    }
    this.configReportForm.patchValue(patch);
    this.configReportForm.updateValueAndValidity();
  }

  selectAllWeekly(select: boolean): void {
    const patch: any = {};
    for (let i = 0; i <= 6; i++) {
      patch[`chkWeek${i}`] = select;
    }
    this.configReportForm.patchValue(patch);
    this.configReportForm.updateValueAndValidity();
  }

  isAllSelected(type: number): boolean {
    if (type === 1) { // Daily
      for (let i = 0; i <= 23; i++) {
        if (!this.configReportForm.get(`chkDaily${i}`)?.value) return false;
      }
      return true;
    } else if (type === 2) { // Monthly
      for (let i = 0; i <= 30; i++) {
        if (!this.configReportForm.get(`chkMonthly${i}`)?.value) return false;
      }
      return true;
    } else if (type === 3) { // Weekly
      for (let i = 0; i <= 6; i++) {
        if (!this.configReportForm.get(`chkWeek${i}`)?.value) return false;
      }
      return true;
    }
    return false;
  }

  toggleAll(type: number): void {
    const select = !this.isAllSelected(type);
    if (type === 1) { // Daily
      this.selectAllDaily(select);
    } else if (type === 2) { // Monthly
      this.selectAllMonthly(select);
    } else if (type === 3) { // Weekly
      this.selectAllWeekly(select);
    }
  }

  toggleNone(type: number): void {
    if (type === 1) { // Daily
      this.selectAllDaily(false);
    } else if (type === 2) { // Monthly
      this.selectAllMonthly(false);
    } else if (type === 3) { // Weekly
      this.selectAllWeekly(false);
    }
  }

  isNoneSelected(type: number): boolean {
    if (type === 1) { // Daily
      for (let i = 0; i <= 23; i++) {
        if (this.configReportForm.get(`chkDaily${i}`)?.value) return false;
      }
      return true;
    } else if (type === 2) { // Monthly
      for (let i = 0; i <= 30; i++) {
        if (this.configReportForm.get(`chkMonthly${i}`)?.value) return false;
      }
      return true;
    } else if (type === 3) { // Weekly
      for (let i = 0; i <= 6; i++) {
        if (this.configReportForm.get(`chkWeek${i}`)?.value) return false;
      }
      return true;
    }
    return false;
  }
  // Count selected methods
  getSelectedDailyCount(): number {
    let count = 0;
    for (let i = 0; i <= 23; i++) {
      if (this.configReportForm.get(`chkDaily${i}`)?.value) count++;
    }
    return count;
  }

  getSelectedMonthlyCount(): number {
    let count = 0;
    for (let i = 0; i <= 30; i++) {
      if (this.configReportForm.get(`chkMonthly${i}`)?.value) count++;
    }
    return count;
  }

  getSelectedWeeklyCount(): number {
    let count = 0;
    for (let i = 0; i <= 6; i++) {
      if (this.configReportForm.get(`chkWeek${i}`)?.value) count++;
    }
    return count;
  }

  getInvalidFields(form: FormGroup): string[] {
    const invalidFields: string[] = [];
    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      if (control && control.invalid) {
        invalidFields.push(key);
      }
    });
    console.log('Invalid fields:', invalidFields);
    return invalidFields;
  }
  onSubmit(): void {
    this.getInvalidFields(this.configReportForm);
    console.log('Schedule validation error:', this.configReportForm);
    if (this.configReportForm.invalid) {
      this.configReportForm.markAllAsTouched();
      this.showScheduleError = true;
      this.alertService.showWarning('Please fill all required fields');
      return;
    }

    this.compileSchedule();
    this.compileDateCaption();

    if (!this.schedule) {
      this.showScheduleError = true;
      this.alertService.showWarning('Please select at least one schedule option');
      return;
    }

    this.saveReportConfig(false);
  }

  onSaveAs(): void {
    if (this.configReportForm.invalid) {
      this.configReportForm.markAllAsTouched();
      this.showScheduleError = true;
      this.alertService.showWarning('Please fill all required fields');
      return;
    }

    this.compileSchedule();
    this.compileDateCaption();

    if (!this.schedule) {
      this.showScheduleError = true;
      this.alertService.showWarning('Please select at least one schedule option');
      return;
    }

    this.saveReportConfig(true);
  }

  private saveReportConfig(isSaveAs: boolean): void {
    this.isSaving = true;
    const formValue = this.configReportForm.value;

    const reportValue = {
      pRowID: isSaveAs ? 0 : +this.ReportConfigID,
      RepID: this.ReportID,
      RepName: formValue.ReportName,
      ReportString: this.filterData,
      DateCaptionText: this.DateCaptionText,
      DateCaptionValue: this.DateCaptionValue,
      ScheduleType: this.ScheduleType,
      Schedule: this.schedule,
      OptionID: "0",
      ReportFooter: formValue.ReportFooter,
      FromUserID: formValue.FromUser,
      EmailUser: formValue.drpEmail.toString(),
      recEnable: formValue.reportEnable ? 1 : 0,
      SendBlankMail: formValue.sendBlankMail ? 1 : 0,
      ReportGroupID: formValue.GroupNameReport
    };

    this.http.post(this.url + 'Report/InsertReportConfig', reportValue)
      .subscribe({
        next: (data) => {
          this.alertService.showSuccess(data.toString());
          this.isSaving = false;
        },
        error: (error) => {
          this.alertService.showError('Failed to save report configuration');
          this.isSaving = false;
        }
      });
  }

  resetForm(): void {
    this.configReportForm.reset({
      GroupNameReport: '0',
      FromUser: '0',
      checkFor: true,
      checkTo: true,
      reportEnable: true,
      sendBlankMail: false,
      ScheduleType: 1
    });
    this.resetScheduleControls();
    this.showScheduleError = false;
  }

  openModal(url: string, cID: string, modelName: string, returnFunction: string): void {
    this.CallFunctionOnCloseModal = returnFunction;
    this.ModelFor = modelName;

    if (modelName === "Column Selection") {
      this.modalURL = "reportcolumn/" + this.ReportID + "/1/" + this.ReportConfigID;
      this.ModalPopUP.show();
    }
  }

  openColumnSelectionModal(): void {
    this.ModelFor = "Column Selection";
    this.modalURL = "reportcolumn/" + this.ReportID + "/1/" + this.ReportConfigID;
    this.ModalPopUP.show();
  }
  onModalClose(): void {
    if (this.CallFunctionOnCloseModal === 'ReturnColumnSelect') {
      this.ReturnColumnSelect();
    }
  }

  ReturnColumnSelect(): void {
    // Handle column selection return
    this.loadExistingReportConfig(); // Reload to get updated column selection
  }
  getUserListing() {
    return this.http.get(this.url + 'GM/GetAllActiveEmployee')
      .pipe(map(data => data ? JSON.parse(data.toString()) : []));
  }

  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data ? JSON.parse(data.toString()) : []));
  }

  // Add this for alert service options
  //   url: string;
  //   addFormConfigReport: FormGroup;
  //   emailList: EmailUserList[] = [];
  //   pageurl: string;
  //   UserList: any;
  //   RightsID: string;
  //   RouteReportGroup: string;
  //   RouteUser: string;
  //   ReportGroup: any;
  //   FromUserList: any;
  //   selectedEmail = [];
  //   CallFunctionOnCloseModal: any;
  //   ModelFor: string;
  //   modalURL: any;
  //   ReportID: string;
  //   filterData: string;
  //   DisplayColumn: number;
  //   ScheduleType: number;
  //   ReportDisplayID: number;
  //   schedule: string;
  //   ReportConfigID: string;
  //   RepportsName: string;
  //   DateCaptionText: string;
  //   DateCaptionValue: string;
  //   counter: any;
  //   options = {
  //     autoClose: true,
  //     keepAfterRouteChange: false
  // };
  //   constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, public datepipe: DatePipe, protected alertService: AlertService) {
  //     this.url = AppComponent.baseURL;
  //    }

  //   ngOnInit() {
  //     this.RightsID = localStorage.getItem('UserRight');
  //     if (this.RightsID.includes('202018001') || this.RightsID.includes('202018021') || this.RightsID.includes('202018000')) {
  //   } else {
  //     window.location.href = "module/0";
  //   }
  //   this.schedule="";
  //    // tslint:disable-next-line: max-line-length
  //    this.RouteReportGroup = this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ? '/general-master/125' : '/module/0';
  //    // tslint:disable-next-line: max-line-length
  //      this.RouteUser = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? '/user-master' : '/module/0';
  //      this.addFormConfigReport = this.formBuilder.group({
  //       ReportName: [''], GroupNameReport: [''], drpEmail: [''], checkFor: [''], checkTo: [''], ReportFooter: [''],
  //       FromUser: [''],reportEnable:[''], sendBlankMail:[''],ScheduleType:[''],
  //       chkWeek0:[''], chkWeek1:[''], chkWeek2:[''], chkWeek3:[''], chkWeek4:[''], chkWeek5:[''], chkWeek6:[''],
  //       chkMonthly0:[''], chkMonthly1:[''], chkMonthly2:[''], chkMonthly3:[''], chkMonthly4:[''], chkMonthly5:[''],
  //       chkMonthly6:[''], chkMonthly7:[''], chkMonthly8:[''], chkMonthly9:[''], chkMonthly10:[''], chkMonthly11:[''],
  //       chkMonthly12:[''], chkMonthly13:[''], chkMonthly14:[''], chkMonthly15:[''], chkMonthly16:[''], chkMonthly17:[''],
  //       chkMonthly18:[''], chkMonthly19:[''], chkMonthly20:[''], chkMonthly21:[''], chkMonthly22:[''], chkMonthly23:[''],
  //       chkMonthly24:[''], chkMonthly25:[''], chkMonthly26:[''], chkMonthly27:[''], chkMonthly28:[''], chkMonthly29:[''],
  //       chkMonthly30:[''],
  //       chkDaily0:[''], chkDaily1:[''], chkDaily2:[''], chkDaily3:[''], chkDaily4:[''], chkDaily5:[''],
  //       chkDaily6:[''], chkDaily7:[''], chkDaily8:[''], chkDaily9:[''], chkDaily10:[''], chkDaily11:[''],
  //       chkDaily12:[''], chkDaily13:[''], chkDaily14:[''], chkDaily15:[''], chkDaily16:[''], chkDaily17:[''],
  //       chkDaily18:[''], chkDaily19:[''], chkDaily20:[''], chkDaily21:[''], chkDaily22:[''], chkDaily23:['']
  //     });
  //     this.addFormConfigReport.patchValue({GroupNameReport:'0',FromUser:'0',
  //       checkFor:true,checkTo:true,reportEnable:true,sendBlankMail:false,
  //       chkWeek0:false, chkWeek1:false, chkWeek2:false, chkWeek3:false, chkWeek4:false, chkWeek5:false, chkWeek6:false,
  //       chkMonthly0:false, chkMonthly1:false, chkMonthly2:false, chkMonthly3:false, chkMonthly4:false, chkMonthly5:false,
  //       chkMonthly6:false, chkMonthly7:false, chkMonthly8:false, chkMonthly9:false, chkMonthly10:false, chkMonthly11:false,
  //       chkMonthly12:false, chkMonthly13:false, chkMonthly14:false, chkMonthly15:false, chkMonthly16:false, chkMonthly17:false,
  //       chkMonthly18:false, chkMonthly19:false, chkMonthly20:false, chkMonthly21:false, chkMonthly22:false, chkMonthly23:false,
  //       chkMonthly24:false, chkMonthly25:false, chkMonthly26:false, chkMonthly27:false, chkMonthly28:false, chkMonthly29:false,
  //       chkMonthly30:false,
  //       chkDaily0:false, chkDaily1:false, chkDaily2:false, chkDaily3:false, chkDaily4:false, chkDaily5:false,
  //       chkDaily6:false, chkDaily7:false, chkDaily8:false, chkDaily9:false, chkDaily10:false, chkDaily11:false,
  //       chkDaily12:false, chkDaily13:false, chkDaily14:false, chkDaily15:false, chkDaily16:false, chkDaily17:false,
  //       chkDaily18:false, chkDaily19:false, chkDaily20:false, chkDaily21:false, chkDaily22:false, chkDaily23:false
  //     });
  //       this.getUserListing().subscribe( (data) => {
  //         this.emailList = data; });
  //         this.http.get(this.url + 'GM/GetEmployee') .subscribe( (data) => {
  //           this.FromUserList = JSON.parse(data.toString()); });
  //     // 060= Diary Plam Type
  //     this.getMaster('125', '') .subscribe( (data: any) => {
  //       this.ReportGroup = data; });
  //     this.pageurl = this.router.url;
  //     let pagehead = this.pageurl.split('/');
  //     this.ReportID= pagehead[2].toString();
  //     this.ReportConfigID=pagehead[3].toString();

  //     if(+pagehead[3]==0){
  //       this.DisplayColumn=0;
  //       this.ReportDisplayID=0;
  //       this.filterData=localStorage.getItem('filterValue').toString();
  //       this.ScheduleType=1;
  //       this.http.get(this.url + 'Report/GetReportDetail?ReportId=' + this.ReportID)
  //       .subscribe( (data) =>   {
  //           if (data == null) {
  //           } else {
  //             const IsGetReportDetail: isGetReportDetail = JSON.parse(data.toString())[0];
  //             this.RepportsName=IsGetReportDetail.ReportName;
  //           }});

  //       //this.RepportsName
  //     } else if(+pagehead[3]>0){
  //       this.ReportDisplayID=1;
  //       this.ScheduleType=1;
  //       this.http.get(this.url + 'Report/GetReportDetail?ReportId=' + this.ReportID)
  //       .subscribe( (data) =>   {
  //           if (data == null) {
  //           } else {
  //             const IsGetReportDetail: isGetReportDetail = JSON.parse(data.toString())[0];
  //             if(IsGetReportDetail.type.toString().trim()=="L"){ this.DisplayColumn=1;}
  //             this.RepportsName=IsGetReportDetail.ReportName;
  //           }});
  //       this.http.get(this.url + 'Report/GetReportConfig?ID=' + this.ReportConfigID)
  //       .subscribe( (data) =>   {
  //               if (data == null) {
  //               } else {
  //                 const RreportConfigInsert: ReportConfigInsert = JSON.parse(data.toString())[0];
  //                 this.counter=0;
  //                 const scaletypes=RreportConfigInsert.DateCaptionValue.split('|',3);
  //                 scaletypes.forEach( scaletype => {
  //                   debugger;
  //                   if(this.counter==0 && scaletype=="1"){
  //                     this.addFormConfigReport.patchValue({ checkFor:true});
  //                   } else if(this.counter==0 && scaletype!="1"){
  //                     this.addFormConfigReport.patchValue({ checkFor:false});
  //                   } if(this.counter==1 && scaletype=="1"){
  //                     this.addFormConfigReport.patchValue({ checkTo:true});
  //                   } else if(this.counter==1 && scaletype!="1"){
  //                     this.addFormConfigReport.patchValue({ checkTo:false});
  //                   }
  //                  this.counter+=1;
  //              });
  //                 this.ScheduleType= RreportConfigInsert.ScheduleType;
  //                 this.setscheduleValue(RreportConfigInsert.Schedule);
  //                  this.selectedEmail = RreportConfigInsert.EmailUser.toString().split(',').map(Number);
  //                  this.filterData=RreportConfigInsert.ReportString;
  //                 this.addFormConfigReport.patchValue({
  //                   ScheduleType: RreportConfigInsert.ScheduleType.toString(),
  //                   ReportName: RreportConfigInsert.RepName , GroupNameReport: RreportConfigInsert.ReportGroupID,
  //                    ReportFooter: RreportConfigInsert.ReportFooter,
  //                   FromUser: RreportConfigInsert.FromUserID ,reportEnable: RreportConfigInsert.recEnable==0?false:true,
  //                   sendBlankMail:RreportConfigInsert.SendBlankMail==0?false:true
  //                 });
  //               }});
  //       //,
  //     }
  //   }
  //   setscheduleValue(schValue){
  //     const schedulevals=schValue.split('|',50);
  //     schedulevals.forEach( scaletype => {
  //       debugger;
  //       if(scaletype=="1"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily0:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly0:true});}        if(this.ScheduleType==3){this.addFormConfigReport.patchValue({ chkWeek0:true});}
  //       } else if(scaletype=="2"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily1:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly1:true});}        if(this.ScheduleType==3){this.addFormConfigReport.patchValue({ chkWeek1:true});}
  //       }  else if(scaletype=="3"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily2:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly2:true});}        if(this.ScheduleType==3){this.addFormConfigReport.patchValue({ chkWeek2:true});}
  //       }  else if(scaletype=="4"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily3:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly3:true});}        if(this.ScheduleType==3){this.addFormConfigReport.patchValue({ chkWeek3:true});}
  //       }  else if(scaletype=="5"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily4:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly4:true});}        if(this.ScheduleType==3){this.addFormConfigReport.patchValue({ chkWeek4:true});}
  //       }  else if(scaletype=="6"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily5:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly5:true});}        if(this.ScheduleType==3){this.addFormConfigReport.patchValue({ chkWeek5:true});}
  //       }  else if(scaletype=="7"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily6:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly6:true});}       if(this.ScheduleType==3){this.addFormConfigReport.patchValue({ chkWeek6:true});}
  //       }  else if(scaletype=="8"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily7:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly7:true});}
  //       } else if(scaletype=="9"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily8:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly8:true});}
  //       } else if(scaletype=="10"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily9:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly9:true});}
  //       } else if(scaletype=="11"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily10:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly10:true});}
  //       } else if(scaletype=="12"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily11:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly11:true});}
  //       } else if(scaletype=="13"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily12:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly12:true});}
  //       } else if(scaletype=="14"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily13:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly13:true});}
  //       } else if(scaletype=="15"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily14:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly14:true});}
  //       } else if(scaletype=="16"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily15:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly15:true});}
  //       } else if(scaletype=="17"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily16:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly16:true});}
  //       } else if(scaletype=="18"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily17:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly17:true});}
  //       } else if(scaletype=="19"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily18:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly18:true});}
  //       } else if(scaletype=="20"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily19:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly19:true});}
  //       } else if(scaletype=="21"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily20:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly20:true});}
  //       } else if(scaletype=="22"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily21:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly21:true});}
  //       } else if(scaletype=="23"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily22:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly22:true});}
  //       } else if(scaletype=="24"){
  //         if(this.ScheduleType==1){this.addFormConfigReport.patchValue({ chkDaily23:true});}  if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly23:true});}
  //       } else if(scaletype=="25"){if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly24:true});}
  //       } else if(scaletype=="26"){if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly25:true});}
  //       } else if(scaletype=="27"){if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly26:true});}
  //       } else if(scaletype=="28"){if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly27:true});}
  //       } else if(scaletype=="29"){if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly28:true});}
  //       } else if(scaletype=="30"){if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly29:true});}
  //       } else if(scaletype=="31"){if(this.ScheduleType==2){this.addFormConfigReport.patchValue({ chkMonthly30:true});}
  //       }
  //  });
  //   }
  //   ReturnColumnSelect() {//after column selection
  //   }
  //   OpenModal(url, cID, modelName, urld)    {
  //     this.CallFunctionOnCloseModal = urld;
  //     this.ModelFor = modelName;
  //     if (modelName == "Column Selection") {
  //       this.modalURL = "#/reportcolumn/" + this.ReportID + "/1/"+ this.ReportConfigID;
  //     }
  //   }
  //   OnScheduleType(ScheduleType){
  //     this.schedule="";
  //     this.ScheduleType=ScheduleType;
  //     this.addFormConfigReport.patchValue({
  //       chkWeek0:false, chkWeek1:false, chkWeek2:false, chkWeek3:false, chkWeek4:false, chkWeek5:false, chkWeek6:false,
  //       chkMonthly0:false, chkMonthly1:false, chkMonthly2:false, chkMonthly3:false, chkMonthly4:false, chkMonthly5:false,
  //       chkMonthly6:false, chkMonthly7:false, chkMonthly8:false, chkMonthly9:false, chkMonthly10:false, chkMonthly11:false,
  //       chkMonthly12:false, chkMonthly13:false, chkMonthly14:false, chkMonthly15:false, chkMonthly16:false, chkMonthly17:false,
  //       chkMonthly18:false, chkMonthly19:false, chkMonthly20:false, chkMonthly21:false, chkMonthly22:false, chkMonthly23:false,
  //       chkMonthly24:false, chkMonthly25:false, chkMonthly26:false, chkMonthly27:false, chkMonthly28:false, chkMonthly29:false,
  //       chkMonthly30:false,
  //       chkDaily0:false, chkDaily1:false, chkDaily2:false, chkDaily3:false, chkDaily4:false, chkDaily5:false,
  //       chkDaily6:false, chkDaily7:false, chkDaily8:false, chkDaily9:false, chkDaily10:false, chkDaily11:false,
  //       chkDaily12:false, chkDaily13:false, chkDaily14:false, chkDaily15:false, chkDaily16:false, chkDaily17:false,
  //       chkDaily18:false, chkDaily19:false, chkDaily20:false, chkDaily21:false, chkDaily22:false, chkDaily23:false
  //     });
  //   }
  //   checkSchedule(HearderFormData)
  //   {
  //     this.schedule="";
  //   if(HearderFormData.chkWeek0==true ||HearderFormData.chkMonthly0==true||HearderFormData.chkDaily0==true){this.schedule+="0|";}
  //   if(HearderFormData.chkWeek1==true ||HearderFormData.chkMonthly1==true||HearderFormData.chkDaily1==true){this.schedule+="1|";}
  //   if(HearderFormData.chkWeek2==true ||HearderFormData.chkMonthly2==true||HearderFormData.chkDaily2==true){this.schedule+="2|";}
  //   if(HearderFormData.chkWeek3==true ||HearderFormData.chkMonthly3==true||HearderFormData.chkDaily3==true){this.schedule+="3|";}
  //   if(HearderFormData.chkWeek4==true ||HearderFormData.chkMonthly4==true||HearderFormData.chkDaily4==true){this.schedule+="4|";}
  //   if(HearderFormData.chkWeek5==true ||HearderFormData.chkMonthly5==true||HearderFormData.chkDaily5==true){this.schedule+="5|";}
  //   if(HearderFormData.chkWeek6==true ||HearderFormData.chkMonthly6==true||HearderFormData.chkDaily6==true){this.schedule+="6|";}
  //   if(HearderFormData.chkMonthly7==true||HearderFormData.chkDaily7==true){this.schedule+="7|";}
  //   if(HearderFormData.chkMonthly8==true||HearderFormData.chkDaily8==true){this.schedule+="8|";}
  //   if(HearderFormData.chkMonthly9==true||HearderFormData.chkDaily9==true){this.schedule+="9|";}
  //   if(HearderFormData.chkMonthly10==true||HearderFormData.chkDaily10==true){this.schedule+="10|";}
  //   if(HearderFormData.chkMonthly11==true||HearderFormData.chkDaily11==true){this.schedule+="11|";}
  //   if(HearderFormData.chkMonthly12==true||HearderFormData.chkDaily12==true){this.schedule+="12|";}
  //   if(HearderFormData.chkMonthly13==true||HearderFormData.chkDaily13==true){this.schedule+="13|";}
  //   if(HearderFormData.chkMonthly14==true||HearderFormData.chkDaily14==true){this.schedule+="14|";}
  //   if(HearderFormData.chkMonthly15==true||HearderFormData.chkDaily15==true){this.schedule+="15|";}
  //   if(HearderFormData.chkMonthly16==true||HearderFormData.chkDaily16==true){this.schedule+="16|";}
  //   if(HearderFormData.chkMonthly17==true||HearderFormData.chkDaily17==true){this.schedule+="17|";}
  //   if(HearderFormData.chkMonthly18==true||HearderFormData.chkDaily18==true){this.schedule+="18|";}
  //   if(HearderFormData.chkMonthly19==true||HearderFormData.chkDaily19==true){this.schedule+="19|";}
  //   if(HearderFormData.chkMonthly20==true||HearderFormData.chkDaily20==true){this.schedule+="20|";}
  //   if(HearderFormData.chkMonthly21==true||HearderFormData.chkDaily21==true){this.schedule+="21|";}
  //   if(HearderFormData.chkMonthly22==true||HearderFormData.chkDaily22==true){this.schedule+="22|";}
  //   if(HearderFormData.chkMonthly23==true||HearderFormData.chkDaily23==true){this.schedule+="23|";}
  //   if(HearderFormData.chkMonthly24==true){this.schedule+="24|";}
  //   if(HearderFormData.chkMonthly25==true){this.schedule+="25|";}
  //   if(HearderFormData.chkMonthly26==true){this.schedule+="26|";}
  //   if(HearderFormData.chkMonthly27==true){this.schedule+="27|";}
  //   if(HearderFormData.chkMonthly28==true){this.schedule+="28|";}
  //   if(HearderFormData.chkMonthly29==true){this.schedule+="29|";}
  //   if(HearderFormData.chkMonthly30==true){this.schedule+="30|";}
  //   }
  //   getUserListing() {
  //     return this.http.get(this.url + 'GM/GetAllActiveEmployee')
  //     .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  //     }
  //   getMaster(GID: string, MID: string) {
  //       return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
  //       .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  //       }
  //       OnSave(HearderFormData) {
  //         this.checkSchedule(HearderFormData);
  //         if (HearderFormData.ReportName == "") { this.alertService.warn('Please Enter Report Name' , this.options); return; }
  //         if (HearderFormData.FromUser == "0") { this.alertService.warn('Please Select from User' , this.options); return; }
  //         if (HearderFormData.drpEmail == "") { this.alertService.warn('Please Select Email' , this.options); return; }
  //         if(this.schedule==""){ this.alertService.warn('Please select any schedule' , this.options); return;}

  //         this.DateCaptionText="";this.DateCaptionValue="";
  //         if(HearderFormData.checkFor==true){this.DateCaptionText+="From|"; this.DateCaptionValue+="1|";}else{
  //           this.DateCaptionText+="|"; this.DateCaptionValue+="0|";
  //         }
  //         if(HearderFormData.checkTo==true){this.DateCaptionText+="To|"; this.DateCaptionValue+="1|";}else{
  //           this.DateCaptionText+="|"; this.DateCaptionValue+="0|";
  //         }
  //                let reportValue: ReportConfigInsert = {
  //                 pRowID: +this.ReportConfigID,
  //                 RepID: this.ReportID,
  //                 RepName: HearderFormData.ReportName,
  //                 ReportString: this.filterData,
  //                 DateCaptionText: this.DateCaptionText,
  //                 DateCaptionValue: this.DateCaptionValue,
  //                 ScheduleType: this.ScheduleType,
  //                 Schedule: this.schedule,
  //                 OptionID: "0",
  //                 ReportFooter: HearderFormData.ReportFooter,
  //                 FromUserID: HearderFormData.FromUser,
  //                 EmailUser: HearderFormData.drpEmail.toString(),
  //                 recEnable: HearderFormData.reportEnable==true?1:0,
  //                 SendBlankMail: HearderFormData.sendBlankMail==true?1:0,
  //                 ReportGroupID: HearderFormData.GroupNameReport
  //                };
  //                this.http.post(this.url + 'Report/InsertReportConfig', reportValue) .subscribe( (data) => {
  //                 this.alertService.success(data.toString() , this.options);
  //                    });

  //           }
  //       OnSaveAs(HearderFormData) {
  //             this.checkSchedule(HearderFormData);
  //             if (HearderFormData.ReportName == "") { this.alertService.warn('Please Enter Report Name' , this.options); return; }
  //             if (HearderFormData.FromUser == "0") { this.alertService.warn('Please Select from User' , this.options); return; }
  //             if (HearderFormData.drpEmail == "") { this.alertService.warn('Please Select Email' , this.options); return; }
  //             if(this.schedule==""){ this.alertService.warn('Please select any schedule' , this.options);  return;}

  //             this.DateCaptionText="";this.DateCaptionValue="";
  //             if(HearderFormData.checkFor==true){this.DateCaptionText+="From|"; this.DateCaptionValue+="1|";}else{
  //               this.DateCaptionText+="|"; this.DateCaptionValue+="0|";
  //             }
  //             if(HearderFormData.checkTo==true){this.DateCaptionText+="To|"; this.DateCaptionValue+="1|";}else{
  //               this.DateCaptionText+="|"; this.DateCaptionValue+="0|";
  //             }
  //                    let reportValue: ReportConfigInsert = {
  //                     pRowID: 0,
  //                     RepID: this.ReportID,
  //                     RepName: HearderFormData.ReportName,
  //                     ReportString: this.filterData,
  //                     DateCaptionText: this.DateCaptionText,
  //                     DateCaptionValue: this.DateCaptionValue,
  //                     ScheduleType: this.ScheduleType,
  //                     Schedule: this.schedule,
  //                     OptionID: "0",
  //                     ReportFooter: HearderFormData.ReportFooter,
  //                     FromUserID: HearderFormData.FromUser,
  //                     EmailUser: HearderFormData.drpEmail.toString(),
  //                     recEnable: HearderFormData.reportEnable==true?1:0,
  //                     SendBlankMail: HearderFormData.sendBlankMail==true?1:0,
  //                     ReportGroupID: HearderFormData.GroupNameReport
  //                    };
  //                    this.http.post(this.url + 'Report/InsertReportConfig', reportValue) .subscribe( (data) => {
  //                     this.alertService.success(data.toString() , this.options);
  //                        });

  //               }
}
